module.exports = __webpack_public_path__ + "static/media/ethax_router.d1eac03a.png";